import { render } from "./DepartmentUserSelector.vue?vue&type=template&id=50df071d&scoped=true"
import script from "./DepartmentUserSelector.vue?vue&type=script&lang=ts"
export * from "./DepartmentUserSelector.vue?vue&type=script&lang=ts"

import "./DepartmentUserSelector.vue?vue&type=style&index=0&id=50df071d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-50df071d"

export default script